import styled from 'styled-components';

export const TopWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	flex-direction: column;
`;

export const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 56px;
	width: 100%;
	background: linear-gradient(271deg, #4322c6 -0.67%, #48068a 101.48%);
	box-sizing: border-box;
	padding: 0 8px;
`;

export const ImageWrapper = styled.div`
	width: 44px;
	overflow: hidden;
	margin-left: 10px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	img {
		width: 100%;
		height: auto;
	}
`;

export const BackIconWrapper = styled.div<{ setShowPopUpTutorial?: boolean }>`
	width: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;

	img {
		width: 100%;
		height: auto;
	}

	@media (min-width: 600px) {
		margin-right: ${(props) => (props.setShowPopUpTutorial ? '80px' : '0px')};
	}
`;

export const LeftWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const NameWrapper = styled.div`
	color: #fff;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	max-width: 250px;
	line-height: 100%; /* 16px */
	letter-spacing: 0.32px;
	text-align: left;
	margin-left: 12px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

export const RefreshWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 10px;

	color: #ded4df;
	width: 16px;

	img {
		width: 100%;
		height: auto;
	}
`;

export const DesktopWrapper = styled.div`
	display: none;

	@media (min-width: 600px) {
		display: flex;
		align-items: center;
	}
`;

export const MobileWrapper = styled.div`
	display: none;

	@media (max-width: 600px) {
		display: flex;
		align-items: center;
	}
`;
